import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcCPAHSDetails from './NcCPAHSDetails';

const NcCPAHSModal = ({ selectedPayable, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            External Bill Id: {selectedPayable.externalBillId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcCPAHSDetails selectedPayable={selectedPayable} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcCPAHSModal;

NcCPAHSModal.propTypes = {
  selectedPayable: PropTypes.instanceOf(Object).isRequired,
};
